import { render, staticRenderFns } from "./create-template.vue?vue&type=template&id=60754e8c&scoped=true"
import script from "./create-template.vue?vue&type=script&lang=js"
export * from "./create-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60754e8c",
  null
  
)

export default component.exports